import React, { useContext, useEffect, useRef, useState } from "react";
import { getData } from "../services/API";
import ThemeOne from "../components/ResumeThemes/ThemeOne";
import ThemeTwo from "../components/ResumeThemes/ThemeTwo";
import ThemeThree from "../components/ResumeThemes/ThemeThree";
import ThemeFour from "../components/ResumeThemes/ThemeFour";
import { useReactToPrint } from "react-to-print";
import { UserData } from "../contexts/UserInfoContext";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { useParams } from "react-router-dom";

const ResumePerview = () => {
  const { user, userLoaded } = useContext(UserData);
  const [loading, setLoading] = useState(true);
  const [once, setOnce] = useState(true);
  const [resume, setResume] = useState({});
  const printCom = useRef();

  const themes = [
    { id: 1, element: <ThemeOne /> },
    { id: 2, element: <ThemeTwo /> },
    { id: 3, element: <ThemeThree /> },
    { id: 4, element: <ThemeFour /> },
  ];

  const param = useParams()

  useEffect(() => {
    const element = document.querySelector('meta[name="viewport"]');
    element.setAttribute("content","width=1024")

    if (once) {
      setOnce(false);
      getData(`/resume/view/${param.userId}`).then((res) => {
        setLoading(false);
        setResume(res.data);
      });
    }
  }, [userLoaded]);

  const handlePrint = useReactToPrint({
    content: () => printCom.current,
  });

  return (
    <div className="w-full min-h-screen h-auto flex flex-col gap-5 py-10 items-center bg-white overflow-x-hidden">
      {loading || !userLoaded ? (
        <span className="text-2xl font-black">لطفا صبر کنید...</span>
      ) : (
        <>
          <button
            onClick={handlePrint}
            className="w-32 h-11 self-center flex justify-center items-center rounded-xl font-black text-white bg-gradient-to-tl from-green-700 to-green-400"
          >
            دانلود رزومه
          </button>
          <div ref={printCom} className="resume-wrapper w-fit h-fit">
            {/* {themes[resume.theme - 1].element} */}
            {resume.theme === 1 ? (
              <ThemeOne data={resume} />
            ) : resume.theme === 2 ? (
              <ThemeTwo data={resume} />
            ) : resume.theme === 3 ? (
              <ThemeThree data={resume} />
            ) : (
              <ThemeFour data={resume} />
            )}
          </div>
          {/* <TransformWrapper maxScale={0.5} initialScale={0.1}>
            <TransformComponent>
            </TransformComponent>
          </TransformWrapper> */}
        </>
      )}
    </div>
  );
};

export default ResumePerview;
